<template>
 <div class="modal zoom" tabindex="-1" role="dialog" id="modalAgendar"> 
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" @click="fecharModal"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title text-left">Formulário de agendamento</h4> 
      </div>
      <div class="modal-body"> 
        <div class="row">
          <div class="col-lg-12 text-left" style="font-size:16px">
            <strong>Dia: <span class="label label-danger" style="font-size:20px">{{ formatarData(this.dia) }}</span> às <span class="label label-default">{{ this.hora }}</span></strong> 
          </div> 
          <div class="col-lg-12 text-left">
            <h4>Pesquisa: </h4>
            <div class="input-group">
              <input type="text" ref="inputPesquisa" class="form-control" v-mask="mascaraPesquisa" placeholder="Digite o código da vaga ou CPF" v-model="pesquisaView" @keyup.enter="pesquisar" @keyup="verificaMascara">
              <span class="input-group-btn">
                  <button class="btn btn-primary" type="button" @click="pesquisar" >
                    <span v-show="!loadPesquisa"><i class="fa fa-search"></i></span>
                    <i class="fa fa-circle-o-notch fa-spin" v-show="loadPesquisa"></i>   
                  </button>
              </span>
            </div>
            <span style=" " v-show="resultadoPesquisaVaga" class="label label-danger">A pesquisa não retornou nenhum resultado.</span> <br /> 
            <div v-show="this.isSemCPF" style="margin-top:-45px;">
              <span style="float:left; margin-top:30px; margin-bottom:10px; width:100%; text-align:left" class="label label-danger">Não encontramos esse CPF em nossa base de dados.</span> <br /> <br />
              <br />
              <div class="input-group">
                <input type="text" ref="inputNome" class="form-control" placeholder="Digite o Nome Completo" v-model="vNome" @keyup.enter="adicionaSemCPF" >
                <span class="input-group-btn">
                    <button class="btn btn-primary" type="button" @click="adicionaSemCPF" > Adicionar </button>
                </span>
              </div>
              <span class="label label-default text-left" style="float:left; margin-top:5px; text-align:left">Preencha o nome completo e, depois, clique em Adicionar.</span> <br />
               
            </div>  
            <div class="containerTabela">
              <table v-show="resultadoPesquisa.length !== 0 && this.isSemCPF === false" class="table table-striped table-bordered">
                <thead>
                    <tr> 
                        <td> </td>
                        <td>Empresa</td>
                        <td>Vaga</td>
                        <td>Ficha</td> 
                        <td>Nome</td>
                        <td>CPF</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="resultadoPesquisa !== undefined" v-for=" row of resultadoPesquisa" :key="row" > 
                        <td><input type="checkbox" :value="row" title="Selecionar" v-model="agendamento"></td>  
                        <td :title="row.RazaoSocial"> {{ row.RazaoSocial == null ? 'N.D.' : row.RazaoSocial.substr(0,25) }} </td>
                        <td> {{ row.IdVaga == null ? 'N.D.' : row.IdVaga }}</td>
                        <td> {{ row.IdFichaAprovacao == null ? 'N.D.' : row.IdFichaAprovacao }} </td>
                        <td class="text-left"><a target="_blank" :href="urlCurriculo + row.Guid" > {{ row.Nome }} </a> </td>
                        <td>{{ row.Cpf }}</td>
                    </tr>    
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="6" class=" label-primary text-center"><strong> .:: Fim ::.  </strong></td>
                  </tr>
                </tfoot>
              </table>
            </div> 
        </div>



          </div>  <hr /> 
          <div class="row">
            <div class="col-lg-6 text-left" style=""> 
              <h4>Selecionados: </h4> 
              <div style="overflow-y:scroll; min-height:150px; max-height:150px; border:1.2px solid #cdcdcd; border-radius:4px"> 
                <table class="table table-striped">
                  <tr v-for="a of agendamento" :key="a">
                    <td  style="border: 1px #cdcdcd; padding:2px;"> <a style="color:#d9534f;" href="#" @click.prevent="tirarDaLista(a)"> <i class="fa fa-remove"></i> </a> </td>
                    <td  style="border: 1px #cdcdcd; padding:2px" class="text-left" >{{ a.Nome }}</td>
                    <td  style="border: 1px #cdcdcd; padding:2px" class="text-right" >{{ a.Cpf }}</td>
                  </tr>
                </table>  
              </div> 
              <div class="row text-left">
               <small v-if="this.agendamento.length > 0" style="margin-left:17px; font-style:italic;">Você selecionou <strong>{{ this.agendamento.length }} </strong> pessoa(s). </small>
               <small v-else style="margin-left:17px; font-style:italic;">Nenhuma pessoa selecionada. </small>
              </div> 
            </div>  
            <div class="col-lg-6 text-left">  
              <h4>Observações: </h4>  
              <textarea style="min-height:150px; max-height:150px;" class="form-control" rows="7" id="observacoes" v-model="observacoes" maxlength="200"></textarea>
              <div class="row text-left">
                <small style="margin-left:17px; font-style:italic;">{{ 200 - this.observacoes.length }} caracteres restantes. </small> 
              </div>
            </div>  
          </div>   
      </div>
      <div class="modal-footer"> 
        <button type="button" class="btn btn-default" @click="fecharModal">Fechar</button>
        <button type="button" class="btn btn-alert" @click="outros">
          <span v-show="!loadOutros">Outros</span>
          <i class="fa fa-circle-o-notch fa-spin" v-show="loadOutros"></i>    
        </button>
        <button type="button" class="btn btn-danger" @click="rescisao">
          <span v-show="!loadRescisao">Rescisão</span>
          <i class="fa fa-circle-o-notch fa-spin" v-show="loadRescisao"></i>    
        </button>
        <button type="button" class="btn btn-info" @click="admissao">
          <span v-show="!loadAdmissao">Admissão</span>
          <i class="fa fa-circle-o-notch fa-spin" v-show="loadAdmissao"></i>   
        </button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
</template>
<script>
import moment from 'moment'
export default{
  name: 'modalAgendar',
  created: function () {
    this.unidade = localStorage.getItem('Unidade')
    this.resultadoPesquisa = []
  },
  components: {
  },
  methods: {
    fecharModal () {
      this.resultadoPesquisa = []
      this.agendamento = []
      this.pesquisaView = ''
      this.observacoes = ''
      this.vNome = ''
      this.loadOutros = false
      this.loadRescisao = false
      this.loadAdmissao = false
      $('#modalAgendar').modal('hide')
    },
    verificaMascara () {
      if (this.pesquisaView.length > 5) {
        this.mascaraPesquisa = '###.###.###-##'
      } else {
        this.mascaraPesquisa = ''
      }
    },
    adicionaSemCPF () {
      let semCPF = {
        Nome: this.vNome,
        Cpf: this.pesquisaView,
        IdEmpresaFilial: 0
      }
      if (this.isSemCPF === true && (this.vNome === '' || this.pesquisaView === '')) {
        alert('Você deve preencher o CPF e o Nome')
        return false
      }
      if (this.vNome !== '') {
        this.agendamento.push(semCPF)
        this.vNome = ''
        this.pesquisaView = ''
        this.isSemCPF = false
        this.$refs.inputPesquisa.focus()
      }
    },
    tirarDaLista (obj) {
      this.agendamento = this.agendamento.filter(function (item) {
        return item.Nome !== obj.Nome
      })
    },
    findByToken: (nome) => {
      this.agendamento.find((usr) => {
        return usr.Nome === nome
      })
    },
    admissao () {
      if (this.hora >= this.HoraAdmissao) {
        alert('Horario limite de admissão: ' + this.HoraAdmissao)
        return false
      }
      let opcaoColetivo = false
      if (this.agendamento.length > 1) {
        alert('Existem ' + this.agendamento.length + ' pessoas selecionadas.\nSerá criado um atendimento coletivo.')
        opcaoColetivo = true
        // if (confirm('Você selecionou mais de uma pessoa. \nDeseja programar atendimento coletivo?')) {
        // } else {
        //   opcaoColetivo = false
        // }
      }
      if (this.agendamento.length === 0 && this.isSemCPF === false) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }

      this.loadAdmissao = true
      let agendamentos = {
        agendamento: this.agendamento,
        tipo: 0,
        coletivo: opcaoColetivo,
        data: this.dia + 'T' + this.hora,
        observacoes: this.observacoes,
        unidade: this.unidade,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }
      this.$http.post('agendamento/salvar', agendamentos)
      .then(function (res) {
        // location.reload()
        this.$emit('atualizarAgenda')
        this.fecharModal()
      })
      .catch(function (err) {
        this.loadAdmissao = false
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    },
    rescisao () {
      if (this.agendamento.length === 0 && this.isSemCPF === false) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      if (this.isSemCPF === true && (this.vNome === '' || this.pesquisaView === '')) {
        alert('Você deve preencher o CPF e o Nome')
        return false
      }
      if (this.vNome !== '') {
        this.agendamento = [{
          Nome: this.vNome,
          Cpf: this.pesquisaView,
          IdEmpresaFilial: 0
        }]
      }
      this.loadRescisao = true
      let agendamentos = {
        agendamento: this.agendamento,
        tipo: 1,
        coletivo: false,
        data: this.dia + 'T' + this.hora,
        observacoes: this.observacoes,
        unidade: this.unidade,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }
      this.$http.post('agendamento/salvar', agendamentos)
      .then(function (res) {
        // location.reload()
        this.$emit('atualizarAgenda')
        this.fecharModal()
      })
      .catch(function (err) {
        this.loadRescisao = true
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    },
    outros () {
      if (this.agendamento.length === 0 && this.isSemCPF === false) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      if (this.postFormulario.observacoes === '') {
        alert('Você deve preencher o campo "Observações"')
      } else {
        if (this.isSemCPF === true && (this.vNome === '' || this.pesquisaView === '')) {
          alert('Você deve preencher o CPF e o Nome')
          return false
        }
        if (this.vNome !== '') {
          this.agendamento = [{
            Nome: this.vNome,
            Cpf: this.pesquisaView,
            IdEmpresaFilial: 0
          }]
        }
        this.loadOutros = true
        let agendamentos = {
          agendamento: this.agendamento,
          tipo: 2,
          coletivo: false,
          data: this.dia + 'T' + this.hora,
          observacoes: this.observacoes,
          unidade: this.unidade,
          IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
        }
        this.$http.post('agendamento/salvar', agendamentos)
        .then(function (res) {
          // location.reload()
          this.$emit('atualizarAgenda')
          this.fecharModal()
        })
        .catch(function (err) {
          this.loadOutros = false
          alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
          console.log(err)
        })
      }
    },
    pesquisar () {
      this.resultadoPesquisa = []
      this.loadPesquisa = true
      this.isSemCPF = false
      this.$http.get('pesquisa?id=' + this.pesquisaView)
      .then(function (res) {
        if (res.body.length === 0) {
          if (this.pesquisaView.length === 14) {
            this.isSemCPF = true
            this.$refs.inputNome.focus()
          } else {
            this.resultadoPesquisaVaga = true
          }
          this.resultadoPesquisa = []
          this.loadPesquisa = false
        } else {
          this.resultadoPesquisa = res.body
          this.loadPesquisa = false
          this.resultadoPesquisaVaga = false
        }
      })
      .catch(function (err) {
        this.loadPesquisa = false
        this.resultadoPesquisa = []
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    },
    formatarData (d) {
      return moment(String(d)).format('DD/MM/YYYY')
    }
  },
  computed: {
    postFormulario: function () {
      return {
        dia: this.diaView,
        hora: this.horaView,
        observacoes: this.observacoes,
        selecionados: this.chk
      }
    },
    postPesquisa: function () {
      return {
        id: this.pesquisaView
      }
    },
    urlCurriculo: function () { return 'http://fastrhluandre.com.br/Curriculo/Visualizar/?confidencial=false&imprimir=true&guid=' },
    urlFicha: function () { return 'http://fastrhluandre.com.br/FichaAprovacao/Visualizar/' },
    urlVaga: function () { return 'http://fastrhluandre.com.br/Vagas/Visualizar/' }
  },
  data () {
    return {
      resultadoPesquisa: [],
      pesquisaView: '',
      diaView: this.dia,
      horaView: this.hora,
      observacoes: '',
      agendamento: [],
      unidade: '',
      loadPesquisa: false,
      loadAdmissao: false,
      loadRescisao: false,
      loadOutros: false,
      vNome: '',
      isSemCPF: false,
      mascaraPesquisa: '',
      resultadoPesquisaVaga: false
    }
  },
  props: ['dia', 'hora', 'HoraAdmissao']
}
</script>
<style scoped>
.btn{
  min-width:100px;
}
.containerTabela{
  overflow-y: scroll;
  max-height: 260px;
}
</style>



// WEBPACK FOOTER //
// ModalAgendar.vue?a5c12274